import { QueryClient } from '@tanstack/react-query';
import { ApiError } from './api';

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 15_000,
      retry: (count, e) =>
        !(e instanceof ApiError && (e.status === 0 || (e.status >= 400 && e.status < 500))) && count < 2,
      refetchOnWindowFocus: true,
    },
  },
});
